import { render, staticRenderFns } from "./talentZone.vue?vue&type=template&id=864f3fc8&scoped=true&"
import script from "./talentZone.vue?vue&type=script&lang=js&"
export * from "./talentZone.vue?vue&type=script&lang=js&"
import style0 from "./talentZone.vue?vue&type=style&index=0&id=864f3fc8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864f3fc8",
  null
  
)

export default component.exports